export const severity = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
};